import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PosCart } from "../types/modules/pos-cart.type";

export interface PosOrderingState {
    selectedCartId?: number;
    selectedCart?: PosCart | null;
    selectedCartStoreId?: number;
}

const initialState: PosOrderingState = {
    selectedCartId: undefined,
    selectedCart: undefined,
    selectedCartStoreId: undefined,
};

const posOrderingSlice = createSlice({
    name: "posOrdering",
    initialState,
    reducers: {
        selectCart: (state, action: PayloadAction<PosCart | null>) => {
            if (action.payload === null) {
                state.selectedCartId = undefined;
                state.selectedCart = null;
                state.selectedCartStoreId = undefined;
            } else {
                state.selectedCartId = action.payload.id;
                state.selectedCart = action.payload;
                state.selectedCartStoreId = action.payload.storeId;
            }
        },
        clearSelection: (state) => {
            state.selectedCartId = undefined;
            state.selectedCart = undefined;
            state.selectedCartStoreId = undefined;
        },
        updateSelectedCart: (state, action: PayloadAction<PosCart>) => {
            if (state.selectedCartId === action.payload.id) {
                state.selectedCart = action.payload;
                state.selectedCartStoreId = action.payload.storeId;
            }
        },
    },
});

export const { selectCart, clearSelection, updateSelectedCart } =
    posOrderingSlice.actions;
export default posOrderingSlice.reducer;
